module.exports = __webpack_public_path__ + "static/media/walmart.cc701b8f.svg";